import { isRectAllInBounds, isRectOutOfBounds } from '@/utils/layer-kit';
import type { TBBox, TMat2D, TPointerEvent } from '../types';
import { iMatrix } from './constants';
import { getScrollLeftTop } from './dom';
import { invertTransform, multiplyTransformMatrices } from './matrix';
import { Point } from './point';

function getTouchInfo(event: TouchEvent | MouseEvent): MouseEvent | Touch {
    const touchProp = (event as TouchEvent).changedTouches;
    if (touchProp && touchProp[0]) {
        return touchProp[0];
    }
    return event as MouseEvent;
}

export const getPointer = (event: TPointerEvent): Point => {
    const element = event.target as HTMLElement,
        scroll = getScrollLeftTop(element),
        _evt = getTouchInfo(event);
    return new Point(_evt.clientX + scroll.left, _evt.clientY + scroll.top);
};

export const sendPointToPlane = (point: Point, from: TMat2D = iMatrix, to: TMat2D = iMatrix): Point =>
    point.transform(calcPlaneChangeMatrix(from, to));

export const calcPlaneChangeMatrix = (from: TMat2D = iMatrix, to: TMat2D = iMatrix) =>
    multiplyTransformMatrices(invertTransform(to), from);

/**
 * 检测边界框是否与指定边界框相交
 * @param rect - 当前边界框
 * @param bounds - 目标边界框
 * @returns 相交信息
 */
export function boundsIntersectsInfo(rect: TBBox, bounds: TBBox) {
    const outOf = isRectOutOfBounds(rect, bounds);
    const allIn = isRectAllInBounds(rect, bounds);
    const partialIn = !allIn && !outOf;

    return {
        /** 有交集 */
        intersects: !outOf,
        /** 完全不在容器内 */
        outOf,
        /** 完全在容器内 */
        allIn,
        /** 部分在容器内 */
        partialIn,
    };
}
